<!--
 * @Description: 批量质检记录弹框
 * @Author: ChenXueLin
 * @Date: 2023-03-09 16:29:31
 * @LastEditTime: 2023-03-10 16:29:47
 * @LastEditors: ChenXueLin
-->
<template>
  <div :class="[batchRecordVisible ? 'dialogMask' : 'hiddenMask']">
    <el-dialog
      title="质检记录"
      :visible.sync="batchRecordVisible"
      :close-on-click-modal="false"
      width="90%"
      v-loading="dialogLoading"
      :element-loading-background="loadingBackground"
      custom-class="audit-dialog"
      :before-close="closeDialog"
      @open="openDialog"
      :modal-append-to-body="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        v-if="type == 'maintenQualityInspection'"
      >
        <el-table
          :data="formData.tableData"
          border
          highlight-current-row
          class="inspectionRecordTable"
        >
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="主体"
            prop="mainBodyId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.mainBodyId`"
                :rules="[{ required: true, message: '请选择主体' }]"
              >
                <e6-vr-select
                  v-model="scope.row.mainBodyId"
                  :data="mainBodyIdList"
                  placeholder="主体"
                  title="主体"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="
                    (val, node) => {
                      changeMainbodyId(val, node, scope.$index);
                    }
                  "
                  @clear="
                    () => {
                      clearMainbodyId(scope.$index);
                    }
                  "
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="故障现象"
            prop="quesReasonId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.quesReasonId`"
                :rules="[{ required: true, message: '请选择故障现象' }]"
              >
                <e6-vr-select
                  v-model="scope.row.quesReasonId"
                  :data="scope.row.quesReasonList"
                  placeholder="故障现象"
                  title="故障现象"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeQuesReasonId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="故障归类"
            prop="failPointId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.failPointId`"
                :rules="[{ required: true, message: '请选择故障归类' }]"
              >
                <e6-vr-select
                  v-model="scope.row.failPointId"
                  :data="scope.row.failPointList"
                  placeholder="故障归类"
                  title="故障归类"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeFailPointId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="处理措施"
            prop="solutionId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.solutionId`"
                :rules="[{ required: true, message: '请选择处理措施' }]"
              >
                <e6-vr-select
                  v-model="scope.row.solutionId"
                  :data="scope.row.solutionList"
                  placeholder="处理措施"
                  title="处理措施"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeSolutionId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="故障原因"
            prop="faultReasonId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.faultReasonId`"
                :rules="[{ required: true, message: '请选择故障原因' }]"
              >
                <e6-vr-select
                  v-model="scope.row.faultReasonId"
                  :data="scope.row.faultReasonList"
                  placeholder="故障原因"
                  title="故障原因"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeFaultReasonId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="责任主体"
            prop="responsibleEntityId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.responsibleEntityId`"
                :rules="[{ required: true, message: '请选择责任主体' }]"
              >
                <e6-vr-select
                  v-model="scope.row.responsibleEntityId"
                  :data="scope.row.responsibleEntityList"
                  placeholder="责任主体"
                  title="责任主体"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeResponsibleEntityId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-form label-width="100px" :model="submitForm" ref="submitForm">
        <el-form-item label="是否工艺纠正" prop="isProcessCorrection">
          <el-switch
            v-model="submitForm.isProcessCorrection"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="纠正内容" prop="processCorrection">
          <el-input
            placeholder="请输入纠正内容"
            v-model="submitForm.processCorrection"
            maxlength="200"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="异常纠正类型" prop="correctiveActionCode">
          <e6-vr-select
            v-model="submitForm.correctiveActionCode"
            :data="correctiveActionCodeList"
            placeholder="异常纠正类型"
            title="异常纠正类型"
            clearable
            :props="{
              id: 'codeId',
              label: 'codeName'
            }"
            virtual
            multiple
            :is-title="true"
          ></e6-vr-select>
        </el-form-item>
        <el-form-item label="上传质检凭证">
          <el-table
            :data="inspectionPhotoReqVOS"
            border
            highlight-current-row
            class="inspectionRecordTable"
          >
            <el-table-column
              show-overflow-tooltip
              align="center"
              header-align="center"
              label="工单号"
              prop="itemId"
              width="80"
            >
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              label="上传质检凭证"
              width="460"
            >
              <template v-slot="scope">
                <inputUpload
                  @copySuccesss="
                    files => {
                      copySuccesss(files, scope.$index);
                    }
                  "
                ></inputUpload>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              prop="fileList"
              label="上传凭证结果"
              width="460"
            >
              <template v-slot="scope">
                <div
                  v-for="(item, index) in scope.row.fileList"
                  :key="index"
                  class="image-item"
                >
                  <el-image
                    :src="item.fileUrl"
                    alt="质检凭证预览"
                    class="preview-image"
                    :preview-src-list="[item.fileUrl]"
                  />
                  <div class="image-actions">
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      @click.stop="removeImage(scope.$index, index)"
                    ></el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              header-align="center"
            >
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="batchUpload(row, $index)"
                  >上传</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button class="cancel" @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import base from "@/mixins/base";
import { uuid } from "vue-uuid";
import inputUpload from "./inputUpload.vue";
import { printError } from "@/utils/util";
import {
  findDownList,
  saveFile,
  uploadOss,
  getObsPostPolicy,
  getFaultClassByParent,
  batchSaveInspectionRecord
} from "@/api";

export default {
  name: "inspectionRecordDialog",
  components: { inputUpload },
  data() {
    return {
      // responsibilityCodeList: [],
      correctiveActionCodeList: [],
      mainBodyIdList: [],
      dialogLoading: false,
      formData: {
        tableData: [
          {
            mainBodyId: "",
            quesReasonId: "",
            failPointId: "",
            solutionId: "",
            faultReasonId: "",
            responsibleEntityId: "",
            // responsibilityCode: "",
            quesReasonList: [],
            failPointList: [],
            solutionList: [],
            faultReasonList: [],
            responsibleEntityList: []
          }
        ]
      },
      submitForm: {
        isProcessCorrection: 0,
        processCorrection: "",
        correctiveActionCode: []
      },
      inspectionPhotoReqVOS: []
    };
  },
  mixins: [base],
  props: {
    batchRecordVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    inspectionPhotoList: {
      type: Array,
      default: () => []
    }
  },

  computed: {},
  watch: {},
  methods: {
    openDialog() {
      this.$nextTick(() => {
        this.inspectionPhotoReqVOS = [...this.inspectionPhotoList];
        if (this.type == "maintenQualityInspection") {
          this.$refs.formData.clearValidate();
        }
      });
      this.resetFormData();
      this.initData();
    },
    // 打开前先置空
    resetFormData() {
      this.formData = {
        tableData: [
          {
            mainBodyId: "",
            quesReasonId: "",
            failPointId: "",
            solutionId: "",
            faultReasonId: "",
            responsibleEntityId: "",
            // responsibilityCode: "",
            quesReasonList: [],
            failPointList: [],
            solutionList: [],
            faultReasonList: [],
            responsibleEntityList: [],
            responsibleConfirm: ""
          }
        ]
      };
      this.submitForm = {
        isProcessCorrection: 0,
        processCorrection: "",
        correctiveActionCode: []
      };
      this.inspectionPhotoReqVOS = [];
    },
    // 初始化数据(获取表头,表格数据)
    async initData() {
      this.dialogLoading = true;
      try {
        let promiseList = [
          findDownList(["CORRECTIVE_ACTION"]),
          getFaultClassByParent({
            parentId: 0,
            parentFaultType: 0,
            faultType: 1
          })
        ];
        let [enumRes, faultRes] = await Promise.all(promiseList);
        // 故障责任归属已移除
        //纠正类型
        this.correctiveActionCodeList = this.getFreezeResponse(enumRes, {
          path: "data.CORRECTIVE_ACTION",
          freeze: false
        });
        this.mainBodyIdList = this.getFreezeResponse(faultRes, {
          path: "data",
          freeze: false
        });
        
        // 初始化表格数据中的主体列表
        let tableData = this.formData.tableData;
        tableData.forEach((item) => {
          this.$set(item, 'mainBodyIdList', this.mainBodyIdList || []);
        });
        this.formData.tableData = tableData;
        
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },

    //清空主体
    clearMainbodyId(index) {
      let tableData = this.formData.tableData;
      this.$set(tableData[index], 'quesReasonList', []);
      this.$set(tableData[index], 'failPointList', []);
      this.$set(tableData[index], 'solutionList', []);
      this.$set(tableData[index], 'faultReasonList', []);
      this.$set(tableData[index], 'responsibleEntityList', []);
      this.$set(tableData[index], 'quesReasonId', "");
      this.$set(tableData[index], 'failPointId', "");
      this.$set(tableData[index], 'solutionId', "");
      this.$set(tableData[index], 'faultReasonId', "");
      this.$set(tableData[index], 'responsibleEntityId', "");
      this.formData.tableData = tableData;
    },
    //修改主体 - 触发后续联动（自动选中并级联加载）
    async changeMainbodyId(val, node, index) {
      if (node && node.faultClassId) {
        let tableData = this.formData.tableData;
        // 清空后续值与选项
        this.$set(tableData[index], 'quesReasonId', "");
        this.$set(tableData[index], 'failPointId', "");
        this.$set(tableData[index], 'solutionId', "");
        this.$set(tableData[index], 'faultReasonId', "");
        this.$set(tableData[index], 'responsibleEntityId', "");
        this.$set(tableData[index], 'quesReasonList', []);
        this.$set(tableData[index], 'failPointList', []);
        this.$set(tableData[index], 'solutionList', []);
        this.$set(tableData[index], 'faultReasonList', []);
        this.$set(tableData[index], 'responsibleEntityList', []);
        this.$set(tableData[index], 'responsibleConfirm', "");
        this.formData.tableData = tableData;

        await this.getFaultClassByLevelReq(node.faultClassId, index, 1, 2, 'quesReasonList', true);
        let parentId = this.formData.tableData[index].quesReasonId;
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 2, 3, 'failPointList', true);
          parentId = this.formData.tableData[index].failPointId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 3, 4, 'solutionList', true);
          parentId = this.formData.tableData[index].solutionId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 4, 5, 'faultReasonList', true);
          parentId = this.formData.tableData[index].faultReasonId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 5, 6, 'responsibleEntityList', true);
        }
      }
    },
    //修改故障现象 - 自动选中并加载后续
    async changeQuesReasonId(val, node, index) {
      if (node && node.faultClassId) {
        let tableData = this.formData.tableData;
        this.$set(tableData[index], 'failPointList', []);
        this.$set(tableData[index], 'solutionList', []);
        this.$set(tableData[index], 'faultReasonList', []);
        this.$set(tableData[index], 'responsibleEntityList', []);
        this.$set(tableData[index], 'responsibleConfirm', "");
        this.formData.tableData = tableData;

        await this.getFaultClassByLevelReq(node.faultClassId, index, 2, 3, 'failPointList', true);
        let parentId = this.formData.tableData[index].failPointId;
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 3, 4, 'solutionList', true);
          parentId = this.formData.tableData[index].solutionId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 4, 5, 'faultReasonList', true);
          parentId = this.formData.tableData[index].faultReasonId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 5, 6, 'responsibleEntityList', true);
        }
      }
    },
    //修改故障归类 - 自动选中并加载后续
    async changeFailPointId(val, node, index) {
      if (node && node.faultClassId) {
        let tableData = this.formData.tableData;
        this.$set(tableData[index], 'solutionList', []);
        this.$set(tableData[index], 'faultReasonList', []);
        this.$set(tableData[index], 'responsibleEntityList', []);
        this.$set(tableData[index], 'responsibleConfirm', "");
        this.formData.tableData = tableData;

        await this.getFaultClassByLevelReq(node.faultClassId, index, 3, 4, 'solutionList', true);
        let parentId = this.formData.tableData[index].solutionId;
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 4, 5, 'faultReasonList', true);
          parentId = this.formData.tableData[index].faultReasonId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 5, 6, 'responsibleEntityList', true);
        }
      }
    },
    //修改处理措施 - 自动选中并加载后续
    async changeSolutionId(val, node, index) {
      if (node && node.faultClassId) {
        let tableData = this.formData.tableData;
        this.$set(tableData[index], 'faultReasonList', []);
        this.$set(tableData[index], 'responsibleEntityList', []);
        this.$set(tableData[index], 'responsibleConfirm', "");
        this.formData.tableData = tableData;

        await this.getFaultClassByLevelReq(node.faultClassId, index, 4, 5, 'faultReasonList', true);
        const parentId = this.formData.tableData[index].faultReasonId;
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 5, 6, 'responsibleEntityList', true);
        }
      }
    },
    //修改故障原因 - 自动选中并加载后续
    async changeFaultReasonId(val, node, index) {
      let tableData = this.formData.tableData;
      const faultReasonList = tableData[index].faultReasonList || [];
      const toStr = v => (v === undefined || v === null ? '' : String(v));
      const selectedId = node && node.faultClassId != null ? node.faultClassId : val;
      const selectedReason = faultReasonList.find(item => toStr(item.faultClassId) === toStr(selectedId));
      if (selectedReason) {
        this.$set(tableData[index], 'responsibleConfirm', selectedReason.customerResponsibility);
      } else if (node) {
        this.$set(tableData[index], 'responsibleConfirm', node.customerResponsibility);
      }
      this.$set(tableData[index], 'responsibleEntityList', []);
      this.formData.tableData = tableData;
      if (node && node.faultClassId) {
        await this.getFaultClassByLevelReq(node.faultClassId, index, 5, 6, 'responsibleEntityList', true);
      }
    },
    //修改责任主体 - 最后一级，无需触发后续联动
    changeResponsibleEntityId(val, node, index) {
      console.log("责任主体选择", val, index);
    },
    //获取故障点
    async getFaultClassByParentReq(parentId, index) {
      try {
        let res = await getFaultClassByParent({
          parentId,
          parentFaultType: 1,
          faultType: 3
        });
        if (res.code == "OK") {
          let tableData = this.formData.tableData;
          tableData[index].failPointList = res.data;
          this.formData.tableData = tableData;
        }
      } catch (error) {
        printError(error);
      }
    },
    //通用方法：根据层级获取故障分类数据
    async getFaultClassByLevelReq(parentId, index, parentFaultType, targetFaultType, targetProperty, autoSelect = false) {
      console.log("targetProperty", targetProperty, 'autoSelect', autoSelect);
      try {
        let res = await getFaultClassByParent({
          parentId,
          parentFaultType: parentFaultType,
          faultType: targetFaultType
        });
        if (res.code == "OK") {
          let tableData = this.formData.tableData;
          const responseData = this.getFreezeResponse(res, {
            path: "data",
            freeze: false
          });
          
          // 使用$set确保Vue能检测到数组内部对象属性的变化
          this.$set(tableData[index], targetProperty, responseData);
          // 自动选中逻辑
          if (autoSelect && responseData.length > 0) {
            let currentId;
            let idProperty;
            switch (targetProperty) {
              case 'quesReasonList':
                idProperty = 'quesReasonId';
                currentId = tableData[index].quesReasonId;
                break;
              case 'failPointList':
                idProperty = 'failPointId';
                currentId = tableData[index].failPointId;
                break;
              case 'solutionList':
                idProperty = 'solutionId';
                currentId = tableData[index].solutionId;
                break;
              case 'faultReasonList':
                idProperty = 'faultReasonId';
                currentId = tableData[index].faultReasonId;
                break;
              case 'responsibleEntityList':
                idProperty = 'responsibleEntityId';
                currentId = tableData[index].responsibleEntityId;
                break;
            }
            if (idProperty && currentId) {
              const toStr = v => (v === undefined || v === null ? '' : String(v));
              const selectedOption = responseData.find(item => toStr(item.faultClassId) === toStr(currentId));
              if (selectedOption) {
                this.$set(tableData[index], idProperty, currentId);
                if (targetProperty === 'faultReasonList') {
                  this.$set(tableData[index], 'responsibleConfirm', selectedOption.customerResponsibility || selectedOption.responsibleConfirm || '');
                }
              } else {
                this.$set(tableData[index], idProperty, "");
              }
            } else if (idProperty && !currentId) {
              const firstOption = responseData[0];
              this.$set(tableData[index], idProperty, firstOption.faultClassId);
              if (targetProperty === 'faultReasonList') {
                this.$set(tableData[index], 'responsibleConfirm', firstOption.customerResponsibility || firstOption.responsibleConfirm || '');
              }
            }
          }
          
          console.log(tableData);
          this.formData.tableData = tableData;
        }
      } catch (error) {
        printError(error);
      }
    },
    //点击添加
    handleAdd() {
      let tableData = this.formData.tableData;
      tableData.push({
        mainBodyId: "",
        quesReasonId: "",
        failPointId: "",
        solutionId: "",
        faultReasonId: "",
        responsibleEntityId: "",
        responsibilityCode: "",
        responsibleConfirm: "",
        quesReasonList: [],
        failPointList: [],
        solutionList: [],
        faultReasonList: [],
        responsibleEntityList: []
      });
      this.formData.tableData = tableData;
    },
    //删除单行
    deleteColumn(index) {
      let tableData = _.cloneDeep(this.formData.tableData);
      if (tableData.length == 1) {
        this.$message.warning("至少保留一条数据");
        return;
      }
      tableData.splice(index, 1);
      this.formData.tableData = tableData;
    },
    //复制图片
    copySuccesss(files, index) {
      let that = this;
      let inspectionPhotoReqVOS = that.inspectionPhotoReqVOS;
      inspectionPhotoReqVOS[index].files = files;
      that.inspectionPhotoReqVOS = inspectionPhotoReqVOS;
    },
    batchUpload(row, index) {
      if (!row.files.length) {
        this.$message.warning("请复制要上传的图片");
        return;
      }
      if (row.files.length > 5) {
        this.$message.warning(
          "上传凭证数量不能超过5张,请删除一些图片后重新点击上传"
        );
        return;
      }
      if (row.fileList.length + row.files.length > 5) {
        this.$message.warning(
          "上传凭证数量不能超过5张,请删除一些图片后重新点击上传"
        );
        return;
      }
      let that = this;
      row.files.map(file => {
        that.getObsSignReq(file, index);
      });
    },
    //点击上传获取签名请求
    async getObsSignReq(file, index) {
      try {
        let fileName = uuid.v1() + "." + file.name;
        let res = await getObsPostPolicy({
          fileType: 2,
          fileName
        });
        if (res.code === "OK") {
          this.configData = res.data;
          this.progressFlag = true;
          this.uploadOssReq(file, fileName, index);
        }
      } catch (error) {
        console.log(error, "签名获取失败");
      }
    },
    //上传到华为云请求
    async uploadOssReq(file, fileName, index) {
      try {
        let configData = this.configData;
        let formData = new FormData();
        let key = configData.key + "/" + fileName;
        formData.append("key", key);
        formData.append("x-obs-acl", "public-read");
        formData.append("content-type", "text/plain");
        formData.append("policy", configData.policy);
        formData.append("AccessKeyId", configData.accesskeyid);
        formData.append("signature", configData.signature);
        formData.append("file", file);
        await uploadOss(
          {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
          },
          configData.url,
          formData
        );
        let allFileUrl =
          "https://e3-oss.obs.cn-east-3.myhuaweicloud.com/" + key;
        let fileObj = {
          allFileUrl,
          dir: key,
          fileType: 2,
          fileName
        };
        this.saveFileReq(fileObj, index);
      } catch (error) {
        console.log(error, "==");
      }
    },
    //获取文件id
    async saveFileReq(fileObj, index) {
      let that = this;
      try {
        let res = await saveFile([fileObj]);
        let resData = res.data[0];
        let inspectionPhotoReqVOS = that.inspectionPhotoReqVOS;
        let fileList = inspectionPhotoReqVOS[index].fileList;
        let obj = {
          fileId: resData.fileId,
          name: resData.fileName,
          fileUrl: resData.allFileUrl
        };
        fileList.push(obj);
        this.inspectionPhotoReqVOS = inspectionPhotoReqVOS;
      } catch (error) {
        console.log(error, "签名获取失败");
      } finally {
        if (this.loadingService) this.loadingService.close();
      }
    },
    // 移除单张图片
    removeImage(index, idx) {
      let inspectionPhotoReqVOS = this.inspectionPhotoReqVOS;
      let fileList = inspectionPhotoReqVOS[index].fileList;
      fileList.splice(idx, 1);
      this.inspectionPhotoReqVOS = inspectionPhotoReqVOS;
    },
    handleSubmit() {
      if (this.type == "maintenQualityInspection") {
        this.$refs.formData.validate(valid => {
          if (valid) {
            this.dialogLoading = true;
            this.saveReq();
          }
        });
      } else {
        this.dialogLoading = true;
        this.saveReq();
      }
    },
    //保存记录
    async saveReq() {
      let recordInfoList = _.cloneDeep(this.formData.tableData);
      // 按照指定格式构造recordInfoList，包含id和name字段
      recordInfoList = recordInfoList.map(item => {
        // 从对应的下拉框数据中查找选中的选项，获取对应的name字段
        const findNameFromList = (list, id) => {
          const found = list.find(option => option.faultClassId === id);
          return found ? found.faultName : "";
        };
        
        // 故障责任归属已移除
        
        return {
          // 故障责任归属已移除
          mainBodyId: item.mainBodyId,
          mainBodyName: findNameFromList(this.mainBodyIdList || [], item.mainBodyId) || "",
          quesReasonId: item.quesReasonId,
          quesReason: findNameFromList(item.quesReasonList, item.quesReasonId) || "",
          failPointId: item.failPointId,
          failPointName: findNameFromList(item.failPointList, item.failPointId) || "",
          solutionId: item.solutionId,
          solution: findNameFromList(item.solutionList, item.solutionId) || "",
          faultReasonId: item.faultReasonId,
          faultReason: findNameFromList(item.faultReasonList, item.faultReasonId) || "",
          responsibleEntityId: item.responsibleEntityId,
          responsibleEntity: findNameFromList(item.responsibleEntityList, item.responsibleEntityId) || "",
          responsibleConfirm: item.responsibleConfirm || ""
        };
      });
      try {
        let res = await batchSaveInspectionRecord({
          recordInfoList:
            this.type == "maintenQualityInspection" ? recordInfoList : [],
          inspectionPhotoReqVOS: this.inspectionPhotoReqVOS,
          ...this.submitForm
        });
        if (res.code == "OK") {
          this.$message.success("保存成功");
          this.$emit("confirm");
          this.closeDialog();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    //关闭弹框
    closeDialog() {
      this.dialogLoading = false;
      this.inspectionPhotoReqVOS=[]
      this.$emit("update:batchRecordVisible", false);
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
/deep/.audit-dialog {
  .el-dialog__body {
    padding: 15px 20px;
    box-sizing: border-box;
    .inspectionRecordTable {
      .e6-vr-select {
        width: 200px;
      }
      [class^="e6-icon"] {
        height: 28px;
        color: #46bfea;
        line-height: 28px;
        font-style: normal;
        text-align: center;
        padding: 0 10px;
        cursor: pointer;
        border-radius: 3px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 28px;
        padding: 0;
        font-size: 20px;
      }
    }

    .image-item {
      width: 80px;
      display: inline-block;
      height: 80px;
      position: relative;
    }

    .preview-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-actions {
      position: absolute;
      top: 5px;
      right: 5px;
    }
  }
}
</style>
